import React, { useEffect, useRef, useState } from "react";
import styles from "../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { url } from "../../../../../App";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ApplicantDetailsModal = ({
  fetchedBorrowerDetails,
  fetchedLoanDetails,
  fetchedCoappDetails,
  closeApplicantModal,
}) => {
  const { loanid } = useParams();
  const [templateId, setTemplateId] = useState("");
  const [templateFields, setTemplateFields] = useState([]);
  console.log(loanid);
  console.log(fetchedBorrowerDetails);
  console.log(fetchedLoanDetails);
  console.log(fetchedCoappDetails);
  const matchedLoans = fetchedLoanDetails.filter(
    (loan) => loan.loan_id === loanid
  );
  console.log(matchedLoans);
  const loan = matchedLoans?.[0];
  const matchedCoapplicants = fetchedCoappDetails.filter(
    (coapp) => coapp.coapplicant_loan_id === loanid
  );
  console.log(matchedCoapplicants);
  const EMAIL = Cookies.get("Email");
  const TOKEN = Cookies.get("Token");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const [isEditableMobile, setIsEditableMobile] = useState(false);
  const [isEditableEmail, setIsEditableEmail] = useState(false);

  const [editedMobile, setEditedMobile] = useState(phoneNumber);
  const [editedEmail, setEditedEmail] = useState(email);

  const [showFieldset, setShowFieldset] = useState(false);
  const [showFieldset2, setShowFieldset2] = useState(false);

  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [saveBtnDisabled2, setSaveBtnDisabled2] = useState(true);

  const [editBtnDisabled, setEditBtnDisabled] = useState(true);
  const [editBtnDisabled2, setEditBtnDisabled2] = useState(true);

  const [editPermission, setEditPermission] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (loan?.mobile) {
      setPhoneNumber(loan?.mobile);
      setEditedMobile(loan?.mobile);
    }
    if (loan?.email) {
      setEmail(loan?.email);
      setEditedEmail(loan?.email);
    }
  }, [loan]);

  useEffect(() => {
    const getTemplate = async () => {
      if (!loan?.template_id) return;
      console.log(loan.template_id);
      setTemplateId(loan.template_id);

      const req = {
        template_id: loan.template_id,
        token: TOKEN,
        email: EMAIL,
      };

      try {
        const res = await axios.post(`${url}/template/getsingle`, req);
        console.log(res?.data[0]?.fields);
        console.log(res?.data[0]);
        setTemplateFields(res?.data[0]?.fields);
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };

    getTemplate();
  }, [loan?.template_id, TOKEN, EMAIL]);

  useEffect(() => {
    axios
      .post(url + "/user/getsingle", {
        token: TOKEN,
        email: EMAIL,
        useremail: EMAIL,
      })
      .then((res) => {
        if (EMAIL === "rupesh.bishnoi@credin.in") {
          setEditPermission(true);
        } else {
          console.log(res?.data[0]);
          if (res.data[0]?.permission?.update_loan_details === true) {
            setEditPermission(true);
          }
        }
      });
  }, [TOKEN, EMAIL]);

  console.log(templateId, loan, "test");

  const toggleFieldset = (type) => {
    if (type === "mobile") {
      setShowFieldset((p) => !p);
      setEditBtnDisabled(true);
      setSaveBtnDisabled(true);
      setIsEditableMobile(false);
    } else {
      setShowFieldset2((p) => !p);
      setEditBtnDisabled2(true);
      setSaveBtnDisabled2(true);
      setIsEditableEmail(false);
    }
  };

  const handleChange = (e, type) => {
    if (type === "mobile") setEditedMobile(e.target.value);
    if (type === "email") setEditedEmail(e.target.value);
  };

  const handleUploadConsent = async (event) => {
    const selectedFile = event.target.files[0];
    console.log(selectedFile);
    if (!selectedFile || selectedFile.type !== "application/pdf") {
      toast.error("PDF only allowed");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64Data = reader.result.split(",")[1];

      const res = await axios.post(url + "/loan/adddoc", {
        token: TOKEN,
        email: EMAIL,
        loan_id: loanid,
        borrower_uniqueno: loan?.borrower_uniqueno,
        fileName: base64Data,
        doc_name: "loan_mis_doc",
        doc_type: "pdf",
      });

      if (res.data.auth) {
        toast.success("Consent uploaded");
        setEditBtnDisabled(false);
        setEditBtnDisabled2(false);
      } else {
        toast.error(res.data.message);
      }
    };

    reader.readAsDataURL(selectedFile);
  };

  const handleFile = () => {
    document.getElementById("fileInput").click();
  };

  const handleEdit = (type) => {
    if (type === "mobile") setIsEditableMobile(true);
    if (type === "email") setIsEditableEmail(true);
  };

  const handleSendOtp = async (type) => {
    const res = await axios.post(url + "/user/lms/otp/send", {
      templateId: "66629e65d6fc051d3e128092",
      email: EMAIL,
      token: TOKEN,
      VAR1: loan?.borrower_name,
      VAR2: type === "mobile" ? "Mobile Number" : "Email Id",
      borrowerMobile: editedMobile,
    });

    if (res.data.type === "success") {
      toast.success(`OTP sent to ${editedMobile}`);
      const otp = prompt(`Enter OTP sent to ${editedMobile}`);
      handleVerifyOtp(otp, type);
    } else {
      toast.error(res.data.type);
    }
  };

  const handleVerifyOtp = async (otp, type) => {
    const res = await axios.post(url + "/user/lms/otp/verify", {
      borrowerOtp: otp,
      email: EMAIL,
      token: TOKEN,
      borrowerMobile: editedMobile,
    });

    if (res.data.type === "success") {
      toast.success("OTP verified");
      console.log(type);

      if (type === "mobile") {
        setIsEditableMobile(false);
        setSaveBtnDisabled(false);
      } else {
        setIsEditableEmail(false);
        setSaveBtnDisabled2(false);
        setEditBtnDisabled2(false);
      }
    } else {
      toast.error("Invalid OTP");
    }
  };
  console.log(isEditableEmail, editBtnDisabled2);

  const handleSubmit = async (type) => {
    const payload =
      type === "mobile"
        ? { updatedMobile: editedMobile }
        : { updatedEmail: editedEmail };

    const res = await axios.patch(url + "/loan/edit/email/mobile", {
      token: TOKEN,
      email: EMAIL,
      loanId: loanid,
      toChange: type === "mobile" ? "Mobile" : "Email",
      ...payload,
    });

    if (res.data.auth) {
      toast.success(res.data.message);

      if (type === "mobile") {
        setShowFieldset(false);
        setSaveBtnDisabled(true);
      } else {
        setShowFieldset2(false);
        setSaveBtnDisabled2(true);
      }
    } else {
      toast.error(res.data.message);
    }
  };
  const formatDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    if (isNaN(date.getTime())) return value;

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <div className={styles.applicantDetailsModal}>
      <div
        className={styles.applicantDetailsModaOverlay}
        onClick={(e) => e.target === e.currentTarget && closeApplicantModal()}
      >
        <div className={styles.applicantDetailsModalContent}>
          <h3>Basic Loan Details</h3>
          <table className={styles.detailsTable}>
            <tbody>
              {[
                ["Loan ID:", loan?.loan_id],
                ["Amount:", loan?.loan_principal_amt],
                ["Status:", loan?.loan_status],
                ["Details Status:", loan?.loan_status],
                ["Type:", loan?.loan_type],
                ["NBFC:", loan?.nbfc_name],
                ["Interest Rate:", loan?.loanproduct_interest_rate],
                ["Tenure:", loan?.loan_duration],
                ["Release Date:", formatDate(loan?.loan_release_date)],
                ["Profession Type:", loan?.loan_professiontype],
                [
                  "Co-Applicant IDs:",
                  matchedCoapplicants.map((c) => c.coapplicant_id).join(", "),
                ],
                ["Mobile Number:", "mobile"],
                ["Email:", "email"],
              ].map(([label, value], i) => (
                <tr key={i}>
                  <td className={styles.labelCell}>{label}</td>

                  <td className={styles.valueCell}>
                    {value === "mobile" && (
                      <>
                        {isEditableMobile ? (
                          <>
                            <input
                              type="text"
                              style={{ width: "120px" }}
                              value={editedMobile}
                              onChange={(e) => handleChange(e, "mobile")}
                            />
                            <button
                              className="verifyButton"
                              onClick={() => handleSendOtp("mobile")}
                            >
                              Verify
                            </button>
                          </>
                        ) : (
                          <>
                            {editedMobile || "-"}
                            {editPermission && (
                              <button
                                onClick={() => toggleFieldset("mobile")}
                                style={{
                                  marginLeft: "15px",
                                  background: "none",
                                  border: "none",
                                  color: "blue",
                                  cursor: "pointer",
                                  padding: 0,
                                }}
                              >
                                (Update)
                              </button>
                            )}
                          </>
                        )}

                        {showFieldset && (
                          <div>
                            <fieldset className="box">
                              <legend>Edit Mobile Number</legend>

                              <div className="main">
                                <input
                                  ref={fileInputRef}
                                  id="fileInput"
                                  type="file"
                                  hidden
                                  onChange={handleUploadConsent}
                                />

                                <button
                                  className="uploadBtn"
                                  onClick={handleFile}
                                >
                                  Upload Consent
                                </button>

                                <button
                                  className="editBtn"
                                  disabled={editBtnDisabled}
                                  onClick={() => handleEdit("mobile")}
                                >
                                  Edit
                                </button>

                                <button
                                  className="saveBtn"
                                  disabled={saveBtnDisabled}
                                  onClick={() => handleSubmit("mobile")}
                                >
                                  Save
                                </button>
                              </div>
                            </fieldset>
                          </div>
                        )}
                      </>
                    )}

                    {value === "email" && (
                      <>
                        {isEditableEmail ? (
                          <input
                            type="text"
                            style={{ width: "200px" }}
                            value={editedEmail}
                            onChange={(e) => handleChange(e, "email")}
                          />
                        ) : (
                          <>
                            {editedEmail || "-"}
                            {editPermission && (
                              <button
                                onClick={() => toggleFieldset("email")}
                                style={{
                                  marginLeft: "15px",
                                  background: "none",
                                  border: "none",
                                  color: "blue",
                                  cursor: "pointer",
                                  padding: 0,
                                }}
                              >
                                (Update)
                              </button>
                            )}
                          </>
                        )}

                        {showFieldset2 && (
                          <div>
                            <fieldset className="box">
                              <legend>Edit Email ID</legend>

                              <div className="main">
                                <button
                                  className="uploadBtn"
                                  onClick={() => handleSendOtp("email")}
                                >
                                  Send OTP
                                </button>

                                <button
                                  className="editBtn"
                                  disabled={editBtnDisabled2}
                                  onClick={() => handleEdit("email")}
                                >
                                  Edit
                                </button>

                                <button
                                  className="saveBtn"
                                  disabled={saveBtnDisabled2}
                                  onClick={() => handleSubmit("email")}
                                >
                                  Save
                                </button>
                              </div>
                            </fieldset>
                          </div>
                        )}
                      </>
                    )}

                    {/* NORMAL FIELDS */}
                    {value !== "mobile" && value !== "email" && (value || "-")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {templateFields
            ?.filter((section) =>
              section.fields?.some((field) => field.type !== "file")
            )
            ?.map((section) => (
              <>
                <h3 style={{ marginBottom: "12px" }}>{section.section_name}</h3>

                <table className={styles.detailsTable}>
                  <tbody>
                    {section.fields
                      ?.filter((field) => field.type !== "file")
                      ?.map((field, fIndex) => {
                        const getFieldValue = (loan, fieldId) => {
                          const allowedReferencePrefixes = [
                            "reference_name_",
                            "reference_number_",
                            "reference_address_",
                            "relationship_with_applicant_",
                          ];

                          if (
                            allowedReferencePrefixes.some((prefix) =>
                              fieldId.startsWith(prefix)
                            )
                          ) {
                            const parts = fieldId.split("_");
                            const index = Number(parts[parts.length - 1]) - 1;
                            const baseKey = parts.slice(0, -1).join("_");

                            return (
                              loan?.reference_details?.[index]?.[baseKey] ?? ""
                            );
                          }

                          const allowedFamilyPrefixes = [
                            "name_",
                            "relationship_",
                            "age_",
                            "occupation_",
                            "phone_",
                          ];
                          
                          if (
                            allowedFamilyPrefixes.some((prefix) =>
                              fieldId.startsWith(prefix)
                            )
                          ) {
                            const parts = fieldId.split("_");
                            const index = Number(parts[parts.length - 1]) - 1;
                            const baseKey = parts.slice(0, -1).join("_");

                            return (
                              loan?.family_details?.[index]?.[baseKey] ?? ""
                            );
                          }

                          return (
                            loan?.[fieldId] ??
                            loan?.dynamic_data?.[fieldId] ??
                            ""
                          );
                        };
                        const value = getFieldValue(loan, field.id);

                        return (
                          <tr key={fIndex}>
                            <td className={styles.labelCell}>{field.label}:</td>
                            <td className={styles.valueCell}>
                              {value
                                ? field.type === "date"
                                  ? formatDate(value)
                                  : value
                                : "-"}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </>
            ))}

          <CloseIcon
            className={styles.CloseIcon}
            onClick={closeApplicantModal}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default ApplicantDetailsModal;
